import * as React from 'react';

function PhotoUploadBallonMobileSvg({ handleClick, ...props }) {
    return (
        <svg
            viewBox="0 0 496 315"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            preserveAspectRatio="none"
            {...props}
        >
            <path
                d="M125.641 10.866c7.192-.508 15.366-1.17 24.189-1.883l28.67-.215c5.532.138 10.027.25 13.127.25 10.656 0 27.241.51 39.431.884 5.826.18 10.648.327 13.339.374 14.602.255 22.873-.24 28.199-1.078L353.161 3.7c2.357-.355 5.371-.759 8.844-1.08C365.427 2.3 369.953 2 375.234 2c65.768 0 119.083 31.786 119.083 109.998 0 22.482-15.164 76.866-25.317 92.502-6.939 5.047-25.571 68.5-65.819 68.5-18.086 0-91.255-9.036-101.315-8.164l-34.88-1.387-3.058-.169-62.913 1.556c-22.515 0-43.015-1.556-60.914-3.611-13.4-1.538-51.497-1.225-60.933-1.031.73.039 1.468.066 2.212.082-5.318.036-5.381-.016-2.212-.082C15.29 256.848.6 169.209 2.12 109.162c0-25.15-3.734-70.45 30.5-89.403 27.387-15.161 62.322-7.623 93.021-8.893z"
                fill="#FFEACC"
            />
            <path
                d="M2.12 109.162C.584 169.896 15.63 258.857 81.38 260.276c-21.151.142 40.821-1.106 58.721.949 17.899 2.055 38.399 3.611 60.914 3.611l62.913-1.556 3.058.169 34.88 1.387c10.06-.872 83.229 8.164 101.315 8.164 40.248 0 58.88-63.453 65.819-68.5 10.153-15.636 25.317-70.02 25.317-92.502C494.317 33.786 441.002 2 375.234 2c-5.281 0-9.807.301-13.229.618-3.473.322-6.487.726-8.844 1.081l-80.565 5.5c-5.326.837-13.597 1.332-28.199 1.077-2.691-.047-7.513-.195-13.339-.374-12.19-.374-28.775-.883-39.431-.883-3.1 0-7.595-.113-13.127-.251l-28.67.215c-8.823.713-16.997 1.375-24.189 1.883-30.699 1.27-65.634-6.268-93.021 8.893-34.234 18.953-30.5 64.253-30.5 89.403z"
                stroke="#FBA919"
                strokeWidth={3}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <text
                fill="#414142"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Roboto"
                fontSize={16}
                letterSpacing=".02em"
            >
                <tspan x={66} y={143.469}>
                    {'\u010Ce se v tvojem osebnem arhivu nahaja kak\u0161na '}
                </tspan>
                <tspan x={66} y={165.469}>
                    {'fotografija te izletni\u0161ke ideje jo lahko nalo\u017Ei\u0161 in '}
                </tspan>
                <tspan x={66} y={187.469}>
                    {'nam s tem pomaga\u0161 ustvarjati bogato zbirko '}
                </tspan>
                <tspan x={66} y={209.469}>
                    {'izletni\u0161kih idej po Sloveniji.'}
                </tspan>
            </text>
            <text
                fill="#FBA919"
                style={{
                    whiteSpace: 'pre'
                }}
                fontFamily="Paytone One"
                fontSize={30}
                letterSpacing="0em"
            >
                <tspan x={66} y={72.95}>
                    {'IMA\u0160 KAK\u0160NO DOBRO '}
                </tspan>
                <tspan x={66} y={107.95}>
                    FOTOGRAFIJO?
                </tspan>
            </text>
            <g onClick={handleClick} style={{ cursor: 'pointer' }}>
                <path
                    d="M181 266c0-11.046 8.954-20 20-20h211v20c0 11.046-8.954 20-20 20H201c-11.046 0-20-8.954-20-20z"
                    fill="#414142"
                />
                <text
                    fill="#fff"
                    style={{
                        whiteSpace: 'pre'
                    }}
                    fontFamily="Roboto"
                    fontSize={14}
                    fontWeight="bold"
                    letterSpacing=".05em"
                >
                    <tspan x={203.099} y={271.285}>
                        DODAJ FOTOGRAFIJE
                    </tspan>
                </text>
                <path
                    d="M385.8 260l6.2 6.3m0 0l-6.2 6.2m6.2-6.2h-16"
                    stroke="#fff"
                    strokeWidth={2}
                    strokeMiterlimit={10}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}

export default PhotoUploadBallonMobileSvg;
